export type PrinterLike = {
  printerId: number | string;
  bins?: string[];
};

/** Matches Product SKU UI fields posted to configuration-service. */
export function buildSkuPrinterFields(
  printerId: number | string | undefined,
  printerBin: string | undefined
) {
  return {
    printerId,
    printerBin,
  };
}

export function resolvePrinterBins(
  printers: PrinterLike[],
  printerId: number | string | undefined
): string[] {
  if (printerId === undefined || printerId === null || printerId === "") {
    return [];
  }
  const id = String(printerId);
  const printer = printers.find((p) => String(p.printerId) === id);
  return printer?.bins ?? [];
}
